import ApiError from 'rde-view-common/constants/ApiError';
import apiInfo, { API_TYPE } from 'rde-view-common/constants/ApiInfo';
import MessageIds from 'rde-view-common/locales/MessageIds';
import { getApiToken } from 'rde-view-common/middleware/auth';
import { getNestedVal, isNotEmpty, isNull, isNotNull, isUndefined } from 'rde-view-common/scripts/functions';
import MessageUtils from 'rde-view-common/scripts/messageUtils';

const qs = require('qs');

/* eslint-disable no-unused-vars */
const GET = 'get';
const POST = 'post';
const PATCH = 'patch';
const DELETE = 'delete';
/* eslint-enable no-unused-vars */

const ignoreApis = [
  // { path: ApiPaths.DATA_ID, method: GET, params: { format: 'zip' } },
];

/**
 * axios
 */
export default function ({ $axios, $config, app, error, redirect }) {
  $axios.onRequest(async (config) => {
    config.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'brackets' });

    // APIInfo取得
    const targetApiInfo = apiInfo[config.url];
    if (isNull(targetApiInfo)) {
      throw new Error(`API path '${config.url}' is Not Defined`);
    } else if ($config.notIgnoreApi !== true) {
      const ignore = ignoreApis
        .find(api => api.path === config.url
          && api.method === config.method.toLowerCase()
          && (isNull(api.params) || Object.keys(api.params).every(key => api.params[key] === config.params[key])));
      if (ignore) {
        throw new IgnoreApiError(config);
      }
    }

    // パスパラメータ抽出・埋め込み
    const pathParams = config.url.match(/{([^}]*)}/g);
    if (isNotEmpty(pathParams)) {
      pathParams
        .map(v => v.substr(1, v.length - 2))
        .forEach(key => {
          config.url = config.url.replace(`{${key}}`, config.params[key]);
          delete config.params[key];
        });
    }

    // HEADER・baseURL設定
    if (targetApiInfo.type === API_TYPE.ENTRIES) {
      // データ受入の場合事業による向き先の切り替えを行う。
      if (isNotNull(app.store.state.programId)) {
        // 受入GUI以外でのアクセスの場合はストアに事業IDを保持し設定値と照らし合わせて判定する。
        const key = Object.keys($config.programs || {})
          .find(key => $config.programs[key].id === app.store.state.programId);
        if (key === 'arim') {
          config.baseURL = $config.apiBaseUrl[targetApiInfo.type + '_arim'].replace(/\/$/, '');
        } else {
          config.baseURL = $config.apiBaseUrl[targetApiInfo.type + '_nims'].replace(/\/$/, '');
        }
      } else {
        // 受入GUIでのアクセスの場合は現在の画面のURLで判定する
        const viewBaseUrlObj = $config.viewBaseUrl;
        const key = Object.keys(viewBaseUrlObj)
          .find(key => viewBaseUrlObj[key].startsWith(location.origin));
        if (key.endsWith('arim')) {
          config.baseURL = $config.apiBaseUrl[targetApiInfo.type + '_arim'].replace(/\/$/, '');
        } else {
          config.baseURL = $config.apiBaseUrl[targetApiInfo.type + '_nims'].replace(/\/$/, '');
        }
      }
    } else {
      config.baseURL = $config.apiBaseUrl[targetApiInfo.type].replace(/\/$/, '');
    }
    const headers = {
      Authorization: `Bearer ${await getApiToken()}`
    };
    let contentType;
    if (targetApiInfo.isRest || isNotNull(config.params?.format)) {
      contentType = 'application/json';
      headers.Accept = 'application/json';
      if (isNotNull(config.params?.format) && config.params.format === 'zip') {
        headers.Accept = 'application/json, application/zip';
      }
    } else {
      contentType = 'application/vnd.api+json';
      headers.Accept = 'application/vnd.api+json';
    }
    config.headers = { ...config.headers, ...headers };
    if (isUndefined(config.headers['Content-Type'])) {
      config.headers['Content-Type'] = contentType;
    }
    console.log('axios config: ', config);
    return config;
  });

  $axios.onResponse((response) => {
  });

  $axios.onError((err) => {
    if (err.config?.url === '/groups/' + app.store.state?.datasets?.targetGroupId + '/members' && err.config?.method === 'post'
      && err?.response?.status === 422) {
      return err;
    }
    if (err.config?.url === '/restructureRequestsAsCsv' && err.config?.method === 'post'
      && err?.response?.status === 422 && isNotEmpty(err?.response?.data?.errorMessages)) {
      return err;
    }
    if (err instanceof IgnoreApiError) {
      err.data = {};
      return err;
    }
    // ステータスコードとエラーオブジェクトを取得
    if (err.response?.data instanceof Blob) {
      showErrorsSync(err, app, error, redirect);
    } else {
      showErrors(err, app, error, redirect);
    }
  });
}

// function handleError(errorInfo, app, status, err, error, redirect) {
function handleError(errorInfo, app, status, errObj, error, redirect) {
  let message;
  // メッセージ生成
  if (isNotNull(errorInfo.getMessage) && errorInfo.getMessage instanceof Function) {
    message = errorInfo.getMessage();
  } else {
    const apiErrorMessage = getNestedVal(errObj, 'detail');
    message = isNull(errorInfo.messageId)
      ? apiErrorMessage
      : errorInfo.messageId === MessageIds.MSG_COM_E_0010
        ? null
        : app.$msg(errorInfo.messageId, getMessageParams(app, errorInfo, errObj));
  }

  if (isNotNull(errorInfo.onError) || errorInfo.onError instanceof Function) {
    errorInfo.onError(errObj);
  }

  if (errorInfo.movesToErrorPage) {
    // エラー画面に遷移
    // メッセージがnullだったらAPIから取得
    app.store.commit('systemErrorObj', { status, message, keepsSession: errorInfo.keepsSession });
    if (redirect instanceof Function) {
      redirect(app.$routes.COMMON_ERROR.path);
      return;
    } else {
      error({ statusCode: status, message });
      return;
    }
  }

  // エラーページ遷移しない場合、表示するメッセージを返却する
  return message;
}

function getMessageParams(app, errorInfo, error) {
  try {
    let params = errorInfo.messageParams;
    if (isNull(params)) return [];
    if (params instanceof Function) params = params(error);
    if (isNull(params)) return [];
    if (!(params instanceof Array)) params = [params];
    return params
      .map(param => {
        const temp = app.$label(param);
        return (isNull(temp) || temp.startsWith('labels.')) ? param : temp;
      });
  } catch (e) {
    console.log(e);
    return [];
  }
}

function showErrors(err, app, error, redirect) {
  const errorMessages = [];
  const errors = getNestedVal(err, 'response', 'data', 'errors');
  const status = err.response?.status || 500;
  if (isNull(errors)) {
    const errorInfo = getNestedVal(err, 'config', 'errorInfo', status) || ApiError[status] || ApiError.default;
    const message = handleError(errorInfo, app, err.response?.status || 500, null, error, redirect);
    errorMessages.push(message);
  } else {
    for (const errObj of errors) {
      const errorKey = err.response.status + '_' + errObj.code;
      const errorInfo = getNestedVal(err, 'config', 'errorInfo', errorKey) || ApiError[errorKey] || ApiError.default;
      const message = handleError(errorInfo, app, err.response.status, errObj, error, redirect);
      errorMessages.push(message);
    }
  }

  // 重複を排除
  const displayMessages = errorMessages
    .filter(val => isNotEmpty(val))
    .filter((x, i, self) => self.indexOf(x) === i);
  // メッセージ表示領域にエラーメッセージを表示
  if (isNotEmpty(displayMessages)) {
    MessageUtils.setMessage(displayMessages);
  }
}

async function showErrorsSync(err, app, error, redirect) {
  const errText = await err.response.data.text();
  err.response.data = JSON.parse(errText);

  showErrors(err, app, error, redirect);
}

class IgnoreApiError extends Error {
  constructor(apiConfig) {
    super();
    console.warn('API call was ignored.', apiConfig);
  }
}
